/**
 * Best-effort human-readable message from an axios error.
 *
 * The API returns plain-text bodies for BadRequest(string)/NotFound(string), `{ error }` for
 * upstream (Stripe) failures, and problem-details (`{ title }`) for model validation. Callers
 * that want to show the server's reason to an operator, instead of a generic failure, go
 * through here.
 */
export const apiErrorMessage = (err: any, fallback: string): string => {
    const data = err?.response?.data;
    if (typeof data === "string" && data.trim()) return data.trim();
    if (data && typeof data === "object") {
        if (typeof data.error === "string" && data.error.trim()) return data.error.trim();
        if (typeof data.title === "string" && data.title.trim()) return data.title.trim();
    }
    if (typeof err?.message === "string" && err.message.trim()) return err.message.trim();
    return fallback;
};
